import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import './dashboard_left.css'

const ClaimsList = () => {
  const [claimsData, setClaimsData] = useState([])
  const [progressMap, setProgressMap] = useState({})
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const search_icon = `${process.env.PUBLIC_URL}/custom-icons/search_icon.png`

  // Discrepancies mock data
  const initialDiscrepancies = Array.from({ length: 9 }, (_, index) => ({
    id: `FM490${40 + index}`,
    issues: Math.floor(Math.random() * 5) + 1
  }))

  useEffect(() => {
    const fetchClaims = async () => {
      try {
        // const response = await axios.post("/agentApis/claims");
        const storedUser = JSON.parse(localStorage.getItem('insuranceUser'))
        console.log('21', storedUser)

        if (!storedUser || !storedUser.userId) {
          console.error('User not logged in')
           alert('User not logged in. Please login again.')
          setClaimsData([])
          return
        }

        // const response = await axios.post("/agentApis/claims");
        const response = await axios.post('/agentApis/claims', {
          userId: storedUser.userId
        })
        const claims = response.data || []

        const sortedClaims = [...claims].sort((a, b) => {
          // Parse date in "DD-MM-YYYY HH:mm:ss" format (all claims वाला logic)
          const parseDateTime = claim => {
            const dateTimeStr =
              claim.claimFromState?.date ||
              claim.date ||
              claim.createdAt ||
              claim.claimIntimationDate

            if (!dateTimeStr) return new Date(0)

            try {
              // example: "29-10-2025 17:11:34"
              const [datePart, timePart] = dateTimeStr.trim().split(' ')
              if (!datePart || !timePart) return new Date(0)

              const [day, month, year] = datePart.split('-').map(Number)
              const [hours, minutes, seconds] = timePart.split(':').map(Number)

              const parsedDate = new Date(
                year,
                month - 1,
                day,
                hours,
                minutes,
                seconds
              )
              return isNaN(parsedDate) ? new Date(0) : parsedDate
            } catch (e) {
              console.error('Date parse error for:', dateTimeStr, e)
              return new Date(0)
            }
          }

          const dateA = parseDateTime(a)
          const dateB = parseDateTime(b)

          // Latest first (newest से oldest)
          return dateB - dateA
        })
        console.log('59', sortedClaims)

        setClaimsData(sortedClaims)
        localStorage.setItem('claimsData', JSON.stringify(sortedClaims))
      } catch (error) {
        console.error('Error fetching claims:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchClaims()
  }, [])

  useEffect(() => {
    const fetchAllProgress = async () => {
      const progressPromises = claimsData.map(async claim => {
        try {
          const res = await axios.post(
            `/process_data/claim_progress/${claim.claimNumber}`
          )
          return { claimNumber: claim.claimNumber, data: res.data }
        } catch (err) {
          return { claimNumber: claim.claimNumber, data: {} }
        }
      })

      const results = await Promise.all(progressPromises)
      const map = {}
      results.forEach(({ claimNumber, data }) => {
        map[claimNumber] = data
      })
      setProgressMap(map)
    }

    if (claimsData.length > 0) {
      fetchAllProgress()
    }
  }, [claimsData])

  const getStep = progressData => {
    if (!progressData) return 2
    let step = 2

    if (progressData.survey_doc && progressData.survey_upload) step = 3

    if (step === 3 && progressData.work_app_update) step = 4

    if (
      step === 4 &&
      (progressData.pre_repair_doc || progressData.pre_repair_upload)
    )
      step = 5

    if (
      step === 5 &&
      (progressData.post_repair_doc || progressData.post_repair_upload)
    )
      step = 6

    if (step === 6 && (progressData.invoice || progressData.pre_invoice))
      step = 7

    if (step === 7 && progressData.delivery) step = 9

    return step
  }

  const handleClaimsDisplay = () => navigate('/claim-display')

  // Enhanced search filter for claims number, vehicle number, and policy number
  const filteredClaims = claimsData.filter(claim => {
    if (!search.trim()) return true

    const searchTerm = search.toLowerCase()
    return (
      (claim.claimNumber &&
        claim.claimNumber.toLowerCase().includes(searchTerm)) ||
      (claim.vehicle && claim.vehicle.toLowerCase().includes(searchTerm)) ||
      (claim.policyNumber &&
        claim.policyNumber.toLowerCase().includes(searchTerm))
    )
  })

  // Filter discrepancies based on search
  const filteredDiscrepancies = initialDiscrepancies.filter(discrepancy => {
    if (!search.trim()) return true
    return discrepancy.id.toLowerCase().includes(search.toLowerCase())
  })

  const handleReviewComponent = (e, claim) => {
    navigate(`/review-page/${claim.claimNumber}`, { state: { claim } })
  }

  const handleButtonClick = (e, claim) => {
    e.stopPropagation()
    navigate(`/claimLanding/${claim.claimNumber}`, { state: { claim } })
  }

  const getStatusText = (stepsCompleted, totalSteps) => {
    if (stepsCompleted === 0) return 'Claim process not started.'
    if (stepsCompleted === totalSteps)
      return 'All steps completed. Claim is ready.'
    return `${stepsCompleted} of ${totalSteps} steps are completed. Finish the steps to complete the claiming process.`
  }

  return (
    <>
      <div className='claims-container'>
        <div className='claims-header'>
          <h1>Claims</h1>
          <button
            className='create-claim-btn'
            onClick={() => navigate('/create-claim')}
          >
            + Create Claim
          </button>
        </div>

        <div className='search-container-left'>
          <img
            src={search_icon}
            alt='search icon'
            className='search-icon-left'
          />
          <input
            type='text'
            placeholder='Search by Claim No, Vehicle No, Policy No'
            className='search-box-left'
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        {loading ? (
          <div className='claims-loading-text'>Loading claims...</div>
        ) : (
          <>
            {/* यहाँ filteredClaims को slice(0,3) से पहले 3 claims show करेंगे */}
            {filteredClaims.slice(0, 3).map((claim, index) => {
              const isLocked = index >= 2
              const progressData = progressMap[claim.claimNumber]
              const currentStep = getStep(progressData)
              const totalSteps = claim.totalSteps || 5

              const percent = Math.round((currentStep / totalSteps) * 100)
              const strokeDashoffset = 100 - percent

              return (
                <div
                  key={claim.id}
                  className={`claim-card ${isLocked ? 'locked-claim' : ''} ${
                    claim.isCompleted ? 'disabled' : ''
                  }`}
                  onClick={e => !isLocked && handleReviewComponent(e, claim)}
                >
                  <div className='claim-header'>
                    <span>Policy: {claim.policyNumber}</span>
                    {claim.date && <span>Date: {claim.date}</span>}
                    <span>Vehicle: {claim.vehicle}</span>
                  </div>

                  <p className='claim-model'>
                    Model: {claim.model} &nbsp; | &nbsp; Make: {claim.make}
                  </p>

                  <div className='claim-progress-container'>
                    <svg className='progress-circle' viewBox='0 0 36 36'>
                      <circle className='background' cx='18' cy='18' r='15' />
                      <circle
                        className='progress'
                        cx='18'
                        cy='18'
                        r='15'
                        strokeDasharray='100'
                        strokeDashoffset={strokeDashoffset}
                      />
                      <text x='50%' y='50%' className='progress-text'>
                        {currentStep}/{totalSteps}
                      </text>
                    </svg>
                    <div className='claim-progress-text'>
                      <h3>{claim.claimNumber}</h3>
                      <p className='status-text'>
                        {getStatusText(currentStep, totalSteps)}
                      </p>
                    </div>
                  </div>

                  {!claim.isCompleted && !isLocked && (
                    <button
                      className='complete-btn'
                      onClick={e => handleButtonClick(e, claim)}
                    >
                      Complete Process
                    </button>
                  )}
                </div>
              )
            })}

            {/* Show message if no claims match search */}
            {filteredClaims.length === 0 && search && (
              <div className='no-results-message'>
                No claims found matching "{search}"
              </div>
            )}

            {/* All Claims Button */}
            <button className='all-claims-btn' onClick={handleClaimsDisplay}>
              All Claims
            </button>
          </>
        )}
      </div>

      {/* Discrepancies section - outside claims-container */}
      <div className='main-card discrepancies-container'>
        <h2>All Discrepancies</h2>

        <div className='card-container1'>
          {filteredDiscrepancies.slice(0, 3).map((discrepancy, index) => (
            <div
              className={`box ${index === 2 ? 'faded-card' : ''}`}
              key={index}
            >
              <div className='box-content'>
                <p className='claim-id'>Claim {discrepancy.id}</p>
                <p className='issues'>⚠️ {discrepancy.issues} Issues found</p>
              </div>
              <button className='review-button'>Review</button>
            </div>
          ))}
        </div>

        {/* Show message if no discrepancies match search */}
        {filteredDiscrepancies.length === 0 && search && (
          <div className='no-results-message'>
            No discrepancies found matching "{search}"
          </div>
        )}

        <button
          className='view-all-btn'
          onClick={() => (window.location.href = '/discrepancies')}
        >
          All Discrepancies
        </button>
      </div>
    </>
  )
}

export default ClaimsList
